import React from "react";
import Layout from "Components/Layouts/Common/common";
import AboutClasses from "./Federal.module.css";
import About3 from "Assets/About/about_3.png";
import Image1 from "Assets/About/about_1.png";
import About_2 from "Assets/About/about_2.png";
import AboutCard from "Components/AboutUs/Cards/Cards";
import Principle from "Components/Cards/Cards";
import Icon1 from "Assets/About/principle_1.png";
import Icon2 from "Assets/About/principle_2.png";
import Icon3 from "Assets/About/principle_3.png";
const Card = [
    {
        icon: Icon1,
        Content:
            "We treat our clients as partners who need help in resolving any issues or filing tax the right way. We are here to shine a light on your problems and bring peace of mind in the toughest of situations.",
        heading: "We bring order to chaos",
    },
    {
        icon: Icon2,
        Content:
            "We treat our clients as partners who need help in resolving any issues or filing tax the right way. We are here to shine a light on your problems and bring peace of mind in the toughest of situations.",
        heading: "We do it right the first time.",
    },
    {
        icon: Icon3,
        Content:
            "At Executive Tax and Accounting Services. there are no excuses. If you need a service provided, we will find a way to complete. it, Our paperwork is accurate and always up to date.",
        heading: "You need it? We provide it.",
    },
];
function About() {
    return (
        <Layout>
            <div className={AboutClasses["Container"]}>
                <header>
                    <h3>
                        Federal and
                        <br /> State
                        <span> Tax Returns</span>{" "}
                    </h3>
                </header>
                <div className={AboutClasses["section-1"]}>
                    <div className={AboutClasses["content"]}>
                        <p>
                            Preparing your own income tax return can be a task
                            that leaves you with more questions than answers.
                            There is no substitute for the knowledge and
                            understanding that a licensed, experienced tax
                            professional can provide and so we are here to help.
                            <br />
                            <br />
                            Serene Tax is dedicated and a registered tax filing
                            company with{" "}
                            <b>electronic return originator (ERO)</b> with IRS
                            by circular 230 Of IRS rules, Tax return process is
                            carried out by our professionals such as CPA's and
                            EA's who holds{" "}
                            <b>Preparer Tax Identification Number (PTIN).</b>
                            <br />
                            <br />
                            We evaluate how significant changes in base pay,
                            bonus compensation, commissions or stock options may
                            affect taxes. and recommend Steps that can reduce
                            that liability.
                        </p>
                    </div>
                    <img src={Image1} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About_2} alt="user" />
                    <div className={AboutClasses["content"]}>
                        {/* <h5>Who we are</h5>{" "} */}
                        <h3>What we ensure:</h3>
                        <ul>
                            <li>
                                We ensure that your returns don't miss out the
                                deductions, credits that you are eligible
                            </li>
                            <li>
                                Your tax return can be filed electronically so
                                you will get a refund back quicker.
                            </li>
                            <li>
                                Our staff will show you how to adjust your
                                payroll withholding to get more money back.
                            </li>
                            <li>Resident Tax Returns — 1040, 1040A, 1040-EZ</li>
                            <li>
                                Non-Resident Tax Returns - 1040NR, 1040NR-EZ
                            </li>
                            <li>Amended Tax Return - 1040X</li>
                            <li>
                                Tax return Preparation — State, City & Local
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default About;
